var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',[_c('a-breadcrumb-item',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message["282"]'))+" ")])]),_c('a-breadcrumb-item',[_vm._v(_vm._s(_vm.$t('message["1439"]')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }